<template>
  <div class="home">
    <img class="bg"
      src="@/assets/images/home.png"
      alt="" />
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style>
.home {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg {
  width: 100%;
}
</style>
